import * as React from 'react';

import { useUniqueId } from '../../Utils';

import { IFileUploadProps } from './FileUpload.type';
import { FileUploadInput, FileUploadInputLabel } from './FileUpload.style';

export const FileUpload = React.forwardRef<HTMLInputElement, IFileUploadProps>(
  ({ variant = 'primary', children, width, alignSelf, flexBasis, flexGrow, flexShrink, order, margin, ...rest }, ref) => {
    const id = useUniqueId('file-upload');

    return (
      <>
        <FileUploadInput {...rest} ref={ref} variant={variant} id={id} className='sr-only' type='file' widthProp={width} />
        <FileUploadInputLabel
          htmlFor={id}
          widthProp={width}
          variant={variant}
          orderProp={order}
          marginProp={margin}
          alignSelf={alignSelf}
          flexBasis={flexBasis}
          flexGrow={flexGrow}
          flexShrink={flexShrink}
        >
          <span>{children}</span>
        </FileUploadInputLabel>
      </>
    );
  },
);

export default FileUpload;
